import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=56af5418&scoped=true&"
import script from "./TheNavbar.vue?vue&type=script&lang=js&"
export * from "./TheNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=56af5418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af5418",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56af5418')) {
      api.createRecord('56af5418', component.options)
    } else {
      api.reload('56af5418', component.options)
    }
    module.hot.accept("./TheNavbar.vue?vue&type=template&id=56af5418&scoped=true&", function () {
      api.rerender('56af5418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Navbar/TheNavbar.vue"
export default component.exports